import { getTestId, RED_600 } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  enableCollapsibleView: true,
  headerElementProps: {
    title: 'Page Content Title',
    subTitle: 'subText',
    iconName: 'AirtelIcon',
    actionTypes: 'icon',
    actionIconName: 'MoreIcon',
    showBulletSeperator: true,
    showInfoIcon: true,
    infoIconTooltipProps: {
      text: 'place descriptor here'
    },
    onHeaderActionPressMetaData: {
      id: 'header-action-click'
    }
  },
  buttonWidgetProps: {
    direction: 'row',
    leftCta: {
      title: 'Button',
      buttonType: 'secondary'
    },
    rightCta: {
      title: 'Button',
      buttonType: 'primary'
    },
    onLeftCtaPress: {
      id: 'left-cta'
    },
    onRightCtaPress: {
      id: 'right-cta'
    },
    testID: 'ButtonWidgetContainer'
  },
  footerElementProps: {
    leftDetails: {
      text: 'Total Amount',
      showInfoTag: true,
      showToolTip: true,
      toolTipProps: {
        text: 'place descriptor here'
      },
      infoTagProps: {
        text: 'Text Label',
        iconName: 'AddEnclosedIcon'
      }
    },
    rightDetails: {
      text: '₹1,508.32',
      showToolTip: true,
      showInfoTag: true,
      toolTipProps: {
        text: 'place descriptor here'
      },
      infoTagProps: {
        text: 'Text Label',
        iconName: 'AddEnclosedIcon'
      }
    }
  },
  masterList: [{
    leftDetails: {
      text: 'Previous Dues',
      showInfoTag: true,
      showToolTip: true,
      toolTipProps: {
        text: 'place descriptor here'
      },
      infoTagProps: {
        text: 'Text Label',
        iconName: 'AddEnclosedIcon'
      }
    },
    rightDetails: {
      text: '₹1800.00',
      color: RED_600,
      showToolTip: true,
      toolTipProps: {
        text: 'place descriptor here'
      }
    },
    isAccordianType: false
  }, {
    leftDetails: {
      text: 'Monthly Charges'
    },
    rightDetails: {
      text: '₹3000.00',
      showInfoTag: true,
      showToolTip: true,
      toolTipProps: {
        text: 'Tool Tip Text'
      }
    },
    isAccordianType: true,
    list: [{
      leftDetails: {
        text: 'Plan Charges',
        showToolTip: true,
        toolTipProps: {
          text: 'Tool Tip Text'
        }
      }
    }, {
      leftDetails: {
        text: 'Xstream Fiber',
        subText: [{
          text: '052246549885_dsl'
        }],
        showInfoTag: true,
        showToolTip: true,
        toolTipProps: {
          text: 'Tool Tip Text'
        },
        infoTagProps: {
          text: 'Text Label',
          iconName: 'AddEnclosedIcon'
        }
      },
      rightDetails: {
        text: '₹500.00',
        showInfoTag: true,
        showToolTip: true,
        toolTipProps: {
          text: 'Tool Tip Text'
        },
        infoTagProps: {
          text: 'Text Label',
          iconName: 'AddEnclosedIcon'
        }
      },
      isAccordianType: true
    }, {
      leftDetails: {
        text: 'Other Charges',
        subText: [{
          text: 'Amazon Prime exclusive offer(Yearly membership)'
        }]
      },
      rightDetails: {
        text: '₹3000.00',
        showInfoTag: true,
        infoTagProps: {
          text: 'Text Label',
          iconName: 'AddEnclosedIcon'
        }
      },
      isAccordianType: true
    }, {
      leftDetails: {
        text: 'DTH',
        subText: [{
          text: '3045732334567-001',
          isClickable: true,
          onTextPressMetaData: {
            id: 'on Text Press Meta Data'
          }
        }]
      },
      rightDetails: {
        text: '₹1000.00',
        subText: [{
          text: '₹500.00'
        }, {
          text: '₹500.00'
        }]
      }
    }, {
      leftDetails: {
        text: 'Postpaid family',
        subText: [{
          text: '9876543210'
        }, {
          text: '9876543210'
        }]
      },
      rightDetails: {
        text: '₹1000.00',
        subText: [{
          text: '₹500.00'
        }, {
          text: '₹500.00'
        }]
      }
    }]
  }, {
    leftDetails: {
      text: 'Taxes'
    },
    rightDetails: {
      text: '₹3000.00'
    }
  }, {
    leftDetails: {
      text: 'Payments'
    },
    rightDetails: {
      text: '-₹1806.00',
      color: 'GREEN_600'
    }
  }, {
    leftDetails: {
      text: 'Adjustments',
      showToolTip: true,
      toolTipProps: {
        text: 'place descriptor here'
      }
    },
    rightDetails: {
      text: '-₹1806.00',
      color: 'GREEN_600',
      showToolTip: true,
      toolTipProps: {
        text: 'place descriptor here'
      }
    }
  }]
}, getTestId('InfoListWidgetContainer'));